module.exports = __webpack_public_path__ + "img/why-back.438a7e8d.jpg";